import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as moment from "moment";
import { forkJoin } from "rxjs";
import { ItemGaleryModel } from "../../models/item-galery.model";
import { NotificationService } from "../../services/notification.service";
import { Utils } from "../../utils";

@Component({
  selector: 'app-complete-info-property',
  templateUrl: './complete-info-property.component.html',
  styleUrls: ['./complete-info-property.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {showError: true},
    },
  ],
})
export class CompleteInfoPropertyComponent {

  public institution: Array<any> = [];
  public formStep1: FormGroup;
  public formStep2: FormGroup;
  public formStep3: FormGroup;
  public formStep4: FormGroup;
  public outsideStep1: boolean = false;
  public loadingSubmit: boolean = false;
  public loading: boolean = false;
  public havePredial: boolean = false;
  public haveIne: boolean = false;
  public haveContract: boolean = false;
  public linkPredial: string = '';
  public linkIne: string = '';
  public linkContract: string = '';
  public continueWithCustomContract: boolean | null = null;


  constructor(
    private readonly dialogRef: MatDialogRef<CompleteInfoPropertyComponent>,
    private readonly formBuild: FormBuilder,
    private readonly snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private input: {
      service: NotificationService,
      user_id: number,
      property_id: number
    }
  ) {
    this.dialogRef.disableClose = true;

    this.formStep1 = this.formBuild.group({
      id: [this.input.property_id],
      user_id: [this.input.user_id],
      initial_date: ['', Validators.required],
      final_date: ['', Validators.required],
      institution_bank_id: ['', Validators.required],
      interbank_clabe: ['', [Validators.required, Validators.minLength(18), Validators.maxLength(18)]],
      predial: [null, Validators.required],
      ine: [null, Validators.required],
      contract: [null, Validators.required],
      deposito: ['', [Validators.pattern(/^\d*\.?\d*$/), Validators.min(0)]],
      mantenimiento: ['', [Validators.pattern(/^\d*\.?\d*$/), Validators.min(0)]],
      luz: [false],
      agua: [false],
      gas: [false],
      telephone: [false],
      servicio_extra1: [''],
      servicio_extra2: [''],
      fiestas: [false],
      mascotas: [false]
    });

    this.formStep2 = this.formBuild.group({
      retrasado: ['', [Validators.min(0), Validators.max(100)]],
      no_aviso: ['', [Validators.min(0)]],
      no_entrega: ['', [Validators.min(0)]]
    });

    this.formStep3 = this.formBuild.group({
      is_moral: [false],
      with_representate: [false],
      no_instrumento_publico: [{value: '', disabled: true}],
      fecha_registro: [{value: '', disabled: true}],
      licenciado: [{value: '', disabled: true}],
      no_notaria_publica: [{value: '', disabled: true}],
      ciudad_registro: [{value: '', disabled: true}],
      folio_mercantil: [{value: '', disabled: true}]
    });

    this.formStep4 = this.formBuild.group({
      is_moral: [{value: false, disabled: true}],
      full_name: [{value: '', disabled: true}],
      no_instrumento_publico: [{value: '', disabled: true}],
      fecha_registro: [{value: '', disabled: true}],
      licenciado: [{value: '', disabled: true}],
      no_notaria_publica: [{value: '', disabled: true}],
      ciudad_registro: [{value: '', disabled: true}]
    });

    this.getinit();
  }

  public getinit(): void {
    this.loading = true;
    forkJoin([this.input.service.getCatalog(), this.input.service.isCompleteInfoProperty(this.input.property_id)]).subscribe((response) => {
      this.institution = response[0].institutions;
      const property = response[1].property;

      if (property.code_available) {
        if (property.code_available.initial_date) {
          this.formStep1.get('initial_date')?.setValue(moment(property.code_available.initial_date).toDate());
        }

        if (property.code_available.final_date) {
          this.formStep1.get('final_date')?.setValue(moment(property.code_available.final_date).toDate());
        }
      }
      
      this.formStep1.get('institution_bank_id')?.setValue(property.bank_info?.institution_bank_id ?? null);
      this.formStep1.get('interbank_clabe')?.setValue(property.bank_info?.interbank_clabe ?? null);
      this.havePredial = property.documents.path_predial != '';
      this.haveIne = property.documents.path_ine != '';
      this.haveContract = property.code_available.path_contract != '';
      this.linkPredial = property.documents.url_predial;
      this.linkIne = property.documents.url_ine;
      this.linkContract = property.code_available.url_contract;

      if (this.havePredial) {
        this.formStep1.get('predial')?.setValidators([]);
        this.formStep1.get('predial')?.updateValueAndValidity();
      }

      if (this.haveIne) {
        this.formStep1.get('ine')?.setValidators([]);
        this.formStep1.get('ine')?.updateValueAndValidity();
      }

      if (this.haveContract) {
        this.formStep1.get('contract')?.setValidators([]);
        this.formStep1.get('contract')?.updateValueAndValidity();
      }
      
      this.loading = false;
    }, err => {
      if (err.status == 400) {
        Utils.showMessage(this.snackBar, 'Exitoso', 'La información para esta propiedad ya fue agregada', 'success', 3500);
      }

      this.loading = false;
      this.close(true);
    });
  }

  public close(value: boolean): void {
    this.dialogRef.close(value);
  }

  public clearPredial(): void {
    this.formStep1.get('predial')!.setValue(null);
    if (this.havePredial) {
      this.formStep1.get('predial')!.setValidators([]);
      this.formStep1.get('predial')!.updateValueAndValidity();
    }
  }

  public setPredial(item: ItemGaleryModel): void {
    this.formStep1.get('predial')!.setValidators([Validators.required]);
    this.formStep1.get('predial')!.updateValueAndValidity();
    if (item.name !== 'error-format') {
      this.formStep1.get('predial')!.setValue(item.file);
    }
  }

  public get validPredial(): boolean {
    return this.formStep1.get('predial')!.value != null;
  }

  public clearIne(): void {
    this.formStep1.get('ine')!.setValue(null);
    if (this.haveIne) {
      this.formStep1.get('ine')!.setValidators([]);
      this.formStep1.get('ine')!.updateValueAndValidity();
    }
  }

  public setIne(item: ItemGaleryModel): void {
    this.formStep1.get('ine')!.setValidators([Validators.required]);
    this.formStep1.get('ine')!.updateValueAndValidity();
    if (item.name !== 'error-format') {
      this.formStep1.get('ine')!.setValue(item.file);
    }
  }

  public get validIne(): boolean {
    return this.formStep1.get('ine')!.value != null;
  }

  public clearContract(): void {
    this.formStep1.get('contract')!.setValue(null);
    if (this.haveContract) {
      this.formStep1.get('contract')!.setValidators([]);
      this.formStep1.get('contract')!.updateValueAndValidity();
    }
  }

  public setContract(item: ItemGaleryModel): void {
    this.formStep1.get('contract')!.setValidators([Validators.required]);
    this.formStep1.get('contract')!.updateValueAndValidity();
    if (item.name !== 'error-format') {
      this.formStep1.get('contract')!.setValue(item.file);
    }
  }
  
  public get validContract(): boolean {
    return this.formStep1.get('contract')!.value != null;
  }

  public interseptedStep1(): void {
    this.outsideStep1 = true;
  }

  public changeMoralStep3(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep3.get('no_instrumento_publico')!.enable();
      this.formStep3.get('fecha_registro')!.enable();
      this.formStep3.get('licenciado')!.enable();
      this.formStep3.get('no_notaria_publica')!.enable();
      this.formStep3.get('ciudad_registro')!.enable();
      this.formStep3.get('folio_mercantil')!.enable();
    } else {
      this.formStep3.get('no_instrumento_publico')!.disable();
      this.formStep3.get('fecha_registro')!.disable();
      this.formStep3.get('licenciado')!.disable();
      this.formStep3.get('no_notaria_publica')!.disable();
      this.formStep3.get('ciudad_registro')!.disable();
      this.formStep3.get('folio_mercantil')!.disable();
    }
  }

  public changeWithRepresentate(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep4.get('is_moral')!.enable();
      this.formStep4.get('full_name')!.enable();
    } else {
      this.formStep4.get('is_moral')!.disable();
      this.formStep4.get('full_name')!.disable();
    }
  }

  public changeMoralStep4(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep4.get('no_instrumento_publico')!.enable();
      this.formStep4.get('fecha_registro')!.enable();
      this.formStep4.get('licenciado')!.enable();
      this.formStep4.get('no_notaria_publica')!.enable();
      this.formStep4.get('ciudad_registro')!.enable();
      this.formStep4.get('folio_mercantil')!.enable();
    } else {
      this.formStep4.get('no_instrumento_publico')!.disable();
      this.formStep4.get('fecha_registro')!.disable();
      this.formStep4.get('licenciado')!.disable();
      this.formStep4.get('no_notaria_publica')!.disable();
      this.formStep4.get('ciudad_registro')!.disable();
      this.formStep4.get('folio_mercantil')!.disable();
    }
  }

  public get validFormWithContract(): boolean {
    const validStartDate = this.formStep1.get('initial_date')?.valid;
    const validEndDate = this.formStep1.get('final_date')?.valid;
    const validBank = this.formStep1.get('institution_bank_id')?.valid;
    const validClabe = this.formStep1.get('interbank_clabe')?.valid;
    const validPerdial = this.formStep1.get('predial')?.valid;
    const validIne = this.formStep1.get('ine')?.valid;
    const validContract = this.formStep1.get('contract')?.valid;

    return [validStartDate, validEndDate, validBank, validClabe, validPerdial, validIne, validContract].every(item => item);
  }

  public setContinueWithCustomContract(value: boolean) {
    this.continueWithCustomContract = value;

    if (!value) {
      this.formStep1.get('contract')?.disable();
    }
  }

  public submit(): void {
    this.loadingSubmit = true;
    const formData = new FormData();

    Object.keys(this.formStep1.value).forEach((key) => {
      let value = this.formStep1.value[key];

      if (key === 'initial_date' || key === 'final_date') {
        value = moment(value).format('YYYY-MM-DD');
      }

      if (key === 'predial' && this.havePredial) {
        if (value == null) {
          value = 'no-insert';
        }
      }

      if (key === 'ine' && this.haveIne) {
        if (value == null) {
          value = 'no-insert';
        }
      }

      if (value !== 'no-insert') {
        formData.append(`property[${key}]`, value);
      }
    });

    Object.keys(this.formStep2.value).forEach((key) => {
      let value = this.formStep2.value[key];

      formData.append(`penalization[${key}]`, value);
    });

    Object.keys(this.formStep3.value).forEach((key) => {
      let value = this.formStep3.value[key];

      formData.append(`contrato[${key}]`, value);
    });

    Object.keys(this.formStep4.value).forEach((key) => {
      let value = this.formStep4.value[key];

      formData.append(`representante[${key}]`, value);
    });

    this.input.service.completeInfoPropertyOwner(formData).subscribe((response) => {
      Utils.showMessage(this.snackBar, 'Exitoso', 'La información fue enviada', 'success', 3500);

      this.loadingSubmit = false;
      this.close(true);
    }, err => {
      this.loadingSubmit = false;

      let errorMessage = 'Por favor intentelo mas tarde';
      if (err.error.details) {
        errorMessage = 'Por favor intentelo mas tarde';
      } else if (typeof err.error === 'object') {
        errorMessage = '';

        Object.keys(err.error).forEach(key => {
          if (Array.isArray(err.error[key])) {
            err.error[key].forEach((messages: any) => {
              errorMessage += `${messages}<br>`;
            });
          } else {
            errorMessage += `${err.error[key]}<br>`;
          }
        });
      }

      Utils.showMessage(this.snackBar, 'Error', errorMessage ?? 'Por favor intentelo mas tarde', 'error', 4000);
    });
  }

  public submitWithContract(): void {
    this.loadingSubmit = true;
    const formData = new FormData();

    Object.keys(this.formStep1.value).forEach((key) => {
      let value = this.formStep1.value[key];

      if (key === 'initial_date' || key === 'final_date') {
        value = moment(value).format('YYYY-MM-DD');
      }

      if (key === 'predial' && this.havePredial) {
        if (value == null) {
          value = 'no-insert';
        }
      }

      if (key === 'ine' && this.haveIne) {
        if (value == null) {
          value = 'no-insert';
        }
      }

      if (key === 'contract' && this.haveContract) {
        if (value == null) {
          value = 'no-insert';
        }
      }

      if (value !== 'no-insert') {
        formData.append(`property[${key}]`, value);
      }
    });

    this.input.service.completeWithCustomContract(formData).subscribe((response) => {
      Utils.showMessage(this.snackBar, 'Exitoso', 'La propiedad ahora se encuentra en renta', 'success', 3500);

      this.loadingSubmit = false;
      this.close(true);
    }, err => {
      this.loadingSubmit = false;

      let errorMessage = 'Por favor intentelo mas tarde';

      if (err.error.details) {
        errorMessage = 'Por favor intentelo mas tarde';
      } else if (typeof err.error === 'object') {
        errorMessage = '';

        Object.keys(err.error).forEach(key => {
          if (Array.isArray(err.error[key])) {
            err.error[key].forEach((messages: any) => {
              errorMessage += `${messages}<br>`;
            });
          } else {
            errorMessage += `${err.error[key]}<br>`;
          }
        });
      }

      Utils.showMessage(this.snackBar, 'Error', errorMessage ?? 'Por favor intentelo mas tarde', 'error', 4000);
    });
  }
}